<template>
  <div>
    <card>
      <div slot="header" class='toolsBar'>
        <div class="leftTools"> 
          <fg-input type="text" placeholder='輸入料號或名稱' v-model="searchForm.number" />
          <el-select class="select-default" placeholder="請選擇" v-model="searchForm.status" clearable="">
            <el-option v-for="i in statusOptions" class="select-default" :value="i.status" :label="i.text" :key="i.id" />
          </el-select>
          <div>
            <l-button type="default" @click="doSearch()">搜尋</l-button>
          </div>
          <!-- <div>
            <l-button type="warning" @click="openModal('outOfStock')">缺貨商品</l-button>
          </div> -->
        </div>
        <div>
          <l-button type="info"  @click="handlenew()" class='text-right'>新增</l-button>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column label="商品料號">
              <div slot-scope="props">
                <b class="font-weight-light">{{props.row.number}}</b>
              </div>
            </el-table-column>
            <el-table-column prop="name" label="商品名稱" />
            <el-table-column label="狀態">
              <div slot-scope="props">
                <b>{{getStatusText(props.row)}}</b>
              </div>
            </el-table-column>
            <el-table-column prop="note" label="備註" />
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'上傳'" class="btn btn-default btn-link btn-xs"
                  @click="handleUpload(props.row.number, props)"
                  v-show="props.row.status !== 1">
                  <i class="fa fa-upload" />
                </a>
                <!-- <a v-tooltip.top-center="'操作紀錄'" class="btn btn-danger btn-link btn-xs" @click="openModal('history')" >
                  <i class="fa fa-bars" style='color:blue' />
                </a> -->

                <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-xs" v-show='props.row.orderGoods.length == 0'
                   @click="handleDelete(props.row.number, props)" >
                  <i class="fa fa-close" style='color:red' />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category" />
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        @input='handleIndexChange'
                        :total="pagination.total" />
        </div>
    </card>

    <el-dialog
      center
      :title="getTitle()"
      :visible.sync="modals.custom">
      <fg-input label="商品料號"
                type="text"
                name="number"
                data-vv-as="商品料號"
                v-model="form.number"
                v-validate="'required'"
                :disabled="form.id !== ''"      
                :error="getError('number')"
                required />
      <fg-input label="商品名稱"
                type="text"
                name="name"
                data-vv-as="商品名稱"
                v-model="form.name"
                :error="getError('name')"
                v-validate="'required'"
                required />
      <fg-input label="備註" name="note">
        <el-input type="textarea" v-model="form.note" />
      </fg-input>
      <div class="text-right">
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
      </div>
    </el-dialog>
    <el-dialog
      center
      title="缺貨商品"
      :visible.sync="modals.outOfStock">
      <div class="text-right">
        Aaaaaa
      </div>
    </el-dialog>
    <el-dialog
      center
      title="操作紀錄"
      :visible.sync="modals.history">
      <div class="text-right">
        操作紀錄操作紀錄操作紀錄操作紀錄操作紀錄操作紀錄操作紀錄
      </div>
    </el-dialog>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import { Pagination as LPagination } from 'src/components/index'
  import lib from '../../lib'
  import tools from '../../tools'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox,
      LPagination
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        form: {
          id: '',
          number: '',
          name: '',
          note: ''
        },
        searchForm: {
          number:'',
          status:'',
        },
        query: {
          number: '',
          status: ''
        },
        statusOptions:[
          { status: 0, text: '新建立'},
          { status: 1, text: '已上傳'},
          { status: 2, text: '上傳失敗'}
        ],
        cuser: null,
        modals: {
          custom: false,
          outOfStock: false,
          history: false
        },
        tableData: []
      }
    },
    async mounted() {
      await this.getData()
    },
    watch: {
      'pagination.currentPage': async function(val) {
      }
    },
    computed: {

    },
    methods: {
      getStatusText(row) {
        var status = row.status
        for (var i = 0; i < this.statusOptions.length; i++) {
          if (this.statusOptions[i]['status'] == status) {
            return this.statusOptions[i]['text']
          }
        }
        return ''
      },
      getTitle() {
        return (this.form.id == '')?'新增商品料號':'編輯商品料號'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;
          if (this.form.id === '') {
            _this.createItem()
          } else {
            // _this.updateUser(this.form)
          }
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },

      // handleEdit (row) {
      //   this.form.id = row.id
      //   this.form.userName = row.userName
      //   this.form.nickname = row.nickname
      //   this.form.password = ''
      //   this.form.userGroupId = row.userGroupId
      //   this.openModal('custom')
      // },
      doSearch() {
        this.pagination.currentPage = 1
        this.query.number = this.searchForm.number
        this.query.status = this.searchForm.status
        this.getData()
      },
      async handleIndexChange(page) {
        await this.getData()
      },
      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.getItmeList(this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          this.tableData = result.items
        }
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          // console.log('clearForm')
          _this.form.id = ''
          _this.form.name = ''
          _this.form.number = ''
          _this.form.note = ''
          resolve()
        })
      },
      async createItem() {
        var data = await lib.createItem(this.form);
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('新增成功', '', 'success')
        } else if (data.status == 7) {
           this.$swal('料號重複', '', 'error')
        } else {
          this.$swal('新增失敗', '', 'error')
        }
      },
      async handleDelete(id, porp) {
        var result = await tools.confirmDialog(this, "確定要刪除?");
        if (result) {
          var data = await lib.deleteItem(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      },
      async handleUpload(id, porp) {
       var result = await tools.confirmDialog(this, `確定要上傳料號?`);
        if (result) {
          var data = await lib.itemUpload(id)
          // console.log('data: ', data)
          if (data.status == 0) {
            this.tableData[porp.$index].status = 1
            this.$notify(
            {
              message:`料號 ${porp.row.number} 已上傳`,
              icon: 'fa fa-user-circle',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: "danger"
            })
          } else {
            this.$swal('上傳失敗', data.msg, 'error')
          }
        }
      }
    }
  }
</script>


<style>
.toolsBar {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}

.leftTools > *{
  padding-right: 10px;
}
</style>
